import { authChannel } from './authChannel';
import { AuthenticationService } from '../../services/authenticationService';
import logger from '../../utils/logger';
import { requestLogout } from './logAuth'
import store from '../../redux/store/store';
import { setDisable } from '../../redux/slices/privateRouteAuthorizations';
import { logout } from '../../redux/slices/routing';


let refreshTimeout = null;
let isRefreshing = false;

const REFRESH_OFFSET = 10; // segundos antes de expirar

// -------------------------------
// Helpers
// -------------------------------
const getExpiry = () => Number(localStorage.getItem('expire-in'));
const getRefreshToken = () => localStorage.getItem('refresh-token');

const clearTimer = () => {
  if (refreshTimeout) {
    clearTimeout(refreshTimeout);
    refreshTimeout = null;
  }
};

// -------------------------------
// Programar refresh
// -------------------------------
export const scheduleTokenRefresh = () => {
  clearTimer();

  const expiry = getExpiry();
  if (!expiry || !getRefreshToken()) return;

  const now = Date.now() / 1000;
  const timeLeft = expiry - now;

  // Ya vencido → refrescar ahora
  if (timeLeft <= 0) {
    refreshAccessToken();
    return;
  }

  const delay = Math.max((timeLeft - REFRESH_OFFSET) * 1000, 0);

  logger.info(`Refresh programado en ${Math.round(delay / 1000)}s`);

  refreshTimeout = setTimeout(() => {
    refreshAccessToken();
  }, delay);
};

// -------------------------------
// Refresh real
// -------------------------------
export const refreshAccessToken = async () => {
  if (isRefreshing) return;

  try {
    isRefreshing = true;
    authChannel.postMessage({ type: 'REFRESH_STARTED' });

    logger.info('Renovando token…');

    const { accessToken, refreshToken, expiresIn } =
      await AuthenticationService.refreshToken();

    const newExpiry = Date.now() / 1000 + expiresIn;

    localStorage.setItem('access-token', accessToken);
    localStorage.setItem('refresh-token', refreshToken);
    localStorage.setItem('expire-in', newExpiry);

    logger.info('Token renovado');

    authChannel.postMessage({ type: 'REFRESH_COMPLETED' });
    scheduleTokenRefresh();
  } catch (err) {
    logger.error('Refresh falló', err);
    authChannel.postMessage({ type: 'REFRESH_FAILED' });
    requestLogout()
  } finally {
    isRefreshing = false;
  }
};


export const performLogout = () => {
  clearTimer();

  localStorage.removeItem('access-token');
  localStorage.removeItem('refresh-token');
  localStorage.removeItem('expire-in');
  localStorage.removeItem('token-type');
  localStorage.removeItem('menuOption')
  localStorage.setItem('authStatus', 'unauthorized');

  store.dispatch(setDisable());
  store.dispatch(logout())
}

// -------------------------------
// Sync entre pestañas
// -------------------------------
authChannel.onmessage = (e) => {
  switch (e.data.type) {

    case 'REFRESH_STARTED':
      isRefreshing = true;
      clearTimer();
      break;

    case 'REFRESH_COMPLETED':
      isRefreshing = false;
      scheduleTokenRefresh();
      break;

    case 'LOGOUT':

      logger.debug('se debe cerrar la sesión')
      performLogout();
      break;

    default:
      break;
  }
}
